<template>
  <div class="testimonial__link">
    <p class="testimonial__link-text">{{item.text}}</p>
    <h3 class="testimonial__link-name">{{item.name}}</h3>
    <p class="testimonial__link-post">{{item.post}}</p>
    <img :src="item.src" :alt="item.alt" class="testimonial__link-image">
  </div>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {};
  },
};
</script>
<style scoped>
  .testimonial__link {
    background-color: #C1CFE3;
    color: #fff;
    border-radius: 48px;
    padding: 24px;
    text-align: center;
  }
  .testimonial__link:nth-child(odd) {
    background-color: #D9AF91;
  }
  .testimonial__link-text {
    font-style: italic;
  }
  .testimonial__link-name {
    color: #fff;
    margin: 0;
  }
  .testimonial__link-post {
    margin-top: 0;
  }
   .testimonial__link-image {
    width: 144px;
    height: 144px;
    object-fit: cover;
    border-radius: 100%;
    margin-top: 6px;
  }

  @media only screen and (max-width: 800px) {
  .testimonial__link {
    grid-column: span 3;
  }
}
</style>